import { Icon } from '@mirai-kids-monte/core/src/components/dataDisplay/Icon';
import styles from './index.module.scss';

export const PromotionAlert = () => (
  <div className={styles.base}>
    <div className={styles['exclamation-mark']}>
      <Icon name="Exclamation" size={15} />
    </div>

    <p>プロモーションを含みます</p>
  </div>
);
